export default __webpack_public_path__ + "static/media/hubspot.b11a4271.svg";